import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminContentCampaignService } from '@/modules/content-campaign/services/admin-content-campaign.service'
import { ContentCampaignCompletedRequestModel } from '@/modules/content-campaign/models/content-campaign-request.model'

@vservice()
export class ContentCampaignCompletedUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminContentCampaignService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(contentCampaignI: number, data: ContentCampaignCompletedRequestModel) {
    return this.service.completed(contentCampaignI, data)
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }
}
